import { useState, useEffect, useContext } from 'react'
import { UserContext } from '../../contexts/UserContext'
import { cellMask, fixPhoneMask, dateFromString } from './masks'
import Step1 from './Steps/step1'
import Step2 from './Steps/step2'

const DadosCadastroPJ = ({
  userData,
  alterarSenha,
  alterarEmail,
  onChange,
  refreshUserData,
  refresh
}) => {
  const [current, setCurrent] = useState(0)
  const [subAtividade, setSubAtividade] = useState([])

  const { user } = useContext(UserContext)

  useEffect(() => {
    onChange(
      cellMask(user.telefoneCelularDDD + user.telefoneCelularNumero),
      'telCel'
    )
    onChange(
      fixPhoneMask(user.telefoneComercialDDD + user.telefoneComercialNumero),
      'telCom'
    )
    onChange(dateFromString(user.dataAbertura), 'abertura')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  if (current === 0)
    return (
      <Step1
        userData={user}
        onChange={onChange}
        alterarSenha={() => alterarSenha()}
        alterarEmail={() => alterarEmail()}
        editarDados={() => setCurrent(1)}
        subAtividade={subAtividade}
        setSubAtividade={setSubAtividade}
      />
    )
  if (current === 1)
    return (
      <Step2
        refreshUserData={refreshUserData}
        refresh={refresh}
        userData={user}
        onChange={onChange}
        subAtividadeDefault={
          subAtividade?.filter(
            (e) => e.subAtividadeId === user.idSubAtividade
          )[0]?.subAtividade
        }
        cancelar={() => setCurrent(0)}
      />
    )
  return null
}

export default DadosCadastroPJ
